/** Auth actiontypes */
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const REST_DATA = 'REST_DATA';
export const LOG_OUT = 'LOGOUT';
export const API_LOADING = 'API_LOADING';
export const SET_RESTAURANT_DETAILS = 'SET_RESTAURANT_DETAILS';
export const SET_WALLET_DETAILS = 'SET_WALLET_DETAILS';
